import { Mapper } from "../../../../base/utils/mapper";
import { TeleconsultaActivateResponseModel } from "../../../../domain/models/consult/teleconsulta-activate-response.model";
import { TeleconsultaActivateResponseEntity } from "../entities/teleconsulta.activate-response.entity";

export class TeleconsultaActivateImplementationRepositoryMapper extends Mapper<TeleconsultaActivateResponseEntity, TeleconsultaActivateResponseModel> {
    mapFrom(param: TeleconsultaActivateResponseEntity): TeleconsultaActivateResponseModel {
        return {
            data:param.data,
            isSuccess:param.isSuccess,
            message:param.message,
            errors:param.errors
        };
    }
    mapTo(param: TeleconsultaActivateResponseModel): TeleconsultaActivateResponseEntity {
        return {
            data:param.data,
            isSuccess:param.isSuccess,
            message:param.message,
            errors:param.errors
        }
    }
}
